var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPplezIcon = function SvgPplezIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#FF6969"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 4.575c.26-.693 1.24-.693 1.5 0l.652 1.745a.8.8 0 0 0 .714.519l1.86.081c.74.032 1.043.965.464 1.425l-1.458 1.16a.8.8 0 0 0-.273.84l.498 1.794c.198.713-.595 1.29-1.212.881l-1.553-1.028a.8.8 0 0 0-.883 0L7.006 13.02c-.617.408-1.41-.168-1.213-.88l.498-1.796a.8.8 0 0 0-.273-.84L4.56 8.346c-.579-.46-.276-1.393.464-1.425l1.86-.081a.8.8 0 0 0 .715-.52l.652-1.744Z",
    fill: "#fff"
  })));
};
export default SvgPplezIcon;